(function() {
    'use strict';
    angular.module('Services').factory('MapService', MapService);
    MapService.$inject = ['Request'];

    function MapService(Request) {
        return {
            route: (success, error, data) => {
                Request.post({
                    url: ApiURLs.osm.route,
                    method: 'POST',
                    successCallback: success,
                    errorCallback: error
                }, data);
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/MapService.js